import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { Field } from "formik";

import SelectDepartment from "../../../shared/components/select-department";
import SelectRole from "shared/components/select-role";
import SelectRoleGroup from "shared/components/select-roleGroup";
import { withTranslate } from "../../../shared/components/translate";
import { Translate } from "react-localize-redux";

const RightsInfo = ({ translate }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="subtitle2">
          {translate("users.form.rights.title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Field
          fullWidth
          isMulti
          component={SelectRoleGroup}
          label={translate("users.form.rights.roleGroups")}
          name="roleGroups"
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          fullWidth
          isMulti
          component={SelectRole}
          label={translate("users.form.rights.roles")}
          name="roles"
        />
      </Grid>
    </Grid>
  );
};

export default withTranslate(RightsInfo);
